"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorDialog = exports.WarningDialog = exports.SuccessDialog = exports.InfoDialog = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var icecream_base_1 = require("icecream-base");
var _1 = tslib_1.__importDefault(require("."));
var Button_1 = tslib_1.__importDefault(require("../Button"));
var ConfigProvider_1 = require("../ConfigProvider");
var icons_1 = require("../icons");
var Footer_1 = require("../Modal/Footer");
var Blue = icecream_base_1.colors.Blue, Green = icecream_base_1.colors.Green, Red = icecream_base_1.colors.Red, Orange = icecream_base_1.colors.Orange;
function StatusFooter() {
    var langData = ConfigProvider_1.useLangData('modal');
    var onOk = Footer_1.useFooterCtx().onOk;
    return react_1.default.createElement(Button_1.default, { type: "primary", onClick: onOk }, langData.okText);
}
function StatusDialog(props) {
    var className = props.className, _a = props.footer, footer = _a === void 0 ? react_1.default.createElement(StatusFooter, null) : _a, rest = tslib_1.__rest(props, ["className", "footer"]);
    var prefix = ConfigProvider_1.usePrefix('dialog-status');
    return (react_1.default.createElement(_1.default, tslib_1.__assign({ className: classnames_1.default(className, prefix), footer: footer }, rest)));
}
function InfoDialog(props) {
    return (react_1.default.createElement(StatusDialog, tslib_1.__assign({ icon: react_1.default.createElement(icons_1.InfoIcon, { style: { color: Blue.blue6 } }) }, props)));
}
exports.InfoDialog = InfoDialog;
function SuccessDialog(props) {
    return (react_1.default.createElement(StatusDialog, tslib_1.__assign({ icon: react_1.default.createElement(icons_1.CheckCircleIcon, { style: { color: Green.green6 } }) }, props)));
}
exports.SuccessDialog = SuccessDialog;
function WarningDialog(props) {
    return (react_1.default.createElement(StatusDialog, tslib_1.__assign({ icon: react_1.default.createElement(icons_1.TipIcon, { style: { color: Orange.orange6 } }) }, props)));
}
exports.WarningDialog = WarningDialog;
function ErrorDialog(props) {
    return (react_1.default.createElement(StatusDialog, tslib_1.__assign({ icon: react_1.default.createElement(icons_1.CloseCircleIcon, { style: { color: Red.red6 } }) }, props)));
}
exports.ErrorDialog = ErrorDialog;
//# sourceMappingURL=status-dialog.js.map